import store from "../store/index"
import ElementUI from "element-ui"
import WSS from "../util/scoketUrl"
const synth = window.speechSynthesis;
const msg = new SpeechSynthesisUtterance();
let global_callback = null
let socket = '' // 存储 WebSocket 连接.
let timeoutObj = null  // 心跳定时器
let err = null  //错误提醒
let suc = null //存在订单
let suc1 = null //存在订单
let suc2 = null //存在订单
let suc3 = null //存在订单
let suc4 = null //存在订单
let num = 0
let clearSetIn = null
// let serverTimoutObj = null // 服务超时定时关闭
let lockReconnect = false // 是否真正建立了连接
let timeoutnum = null // 重新连接的定时器，  没连接上会一直重连，设置延迟避免请求过多
const socketConfig = {
  url: '',
  retryTimeout: 20000 // 心跳时间 暂定20s
}

// export const sendWebsocket = function (agentData, callback) {
//   global_callback = callback
//   socketOnSend(agentData)
// }

export const initWebSocket = function (url) {
  console.log("进来了", store.state.socket)
  let accessToken = localStorage.getItem("accessToken");
  let weburl = WSS + store.state.socket
  console.log(weburl, "socket.js")
  if (!accessToken) return
  socket = new WebSocket(weburl)
  clearSetIn = null
  socketOnOpen()
  socketOnClose()
  socketOnError()
  socketOnMessage()
}

/**
 * 关闭websocket函数
 */
export const closeWebsocket = function () {
  clearTimeout(timeoutObj)
  try {
    if (socket) {
      socket.close();
      localStorage.setItem("socketFlg", "0");
    }
  } catch (err) {
    console.error(err)
  }
}

function socketOnOpen() {
  socket.onopen = () => {

    localStorage.setItem("socketFlg", 1)
    ElementUI.Notification({
      title: "消息推送连接成功",
      duration: 9000,
    });
    console.log("推送连接成功")
    console.log(socket)
    clearSetIn = setInterval(socketOnSend(), 600000)
    // reset()
    // }
  }

}
// 重连
function reconnect() {
  let flg = localStorage.getItem("socketFlg")
  console.log(flg == 1 || num == 1)
  if (flg == 1 || num == 1) {
    console.log(lockReconnect)
    if (lockReconnect) {
      return
    }
    lockReconnect = true
    timeoutnum && clearTimeout(timeoutnum)
    timeoutnum = setTimeout(() => {
      if (err != null) {
        err.close()
        err = null
      }
      // err = ElementUI.Notification({
      //   title: "消息推送遇到错误",
      //   duration: 7000,
      //   message: "正在尝试重连或手动刷新",
      // });
      initWebSocket()
      lockReconnect = false
    }, 500);
  } else {
    clearTimeout(timeoutnum)
    return false
  }

}
function socketOnClose() {
  socket.onclose = (e) => {
    clearInterval(clearSetIn)
    let close = localStorage.getItem("close")
    let flg = store.state.logOutFlg
    console.log(flg, e, close, num, "flgflgflgflg")
    if (localStorage.getItem("socketFlg") == 0 || localStorage.getItem("socketFlg") == "0" || num == 1) {
      console.log("websocket断开了")``

      if (num == 1) {
        if (flg == 2) {
          console.log('flg == 2')
          localStorage.removeItem("storeInfo")
        }
        clearInterval(clearSetIn)
        localStorage.removeItem("refreshToken")
        localStorage.removeItem("accessToken")
        localStorage.removeItem("socketFlg")
        location.reload()
      }
    } else if (close == 2) {
      return false
    } else {
      reconnect()
    }
  }
}
function socketOnError() {
  socket.onerror = () => {
    clearInterval(clearSetIn)
    let flg = localStorage.getItem("socketFlg")
    if (flg != 0) {
      reconnect()
    }
    console.log('socket 连接失败')
  }
}
// 发送消息
function socketOnSend() {
  let date = new Date()
  console.log(date.toString())
  socket.send("beat")
  return socketOnSend
}
// 收到消息
function socketOnMessage() {
  socket.onmessage = (e) => {
    console.log(e.data)
    if (e.data == 'close') {
      // clearInterval(clearSetIn)
      // num = 1
      ElementUI.Notification({
        title: "按F5重连Socket",
        message: '消息推送断连',
        duration: 0,
      });
      // socket.onclose()
      localStorage.setItem("socketFlg", "0")
    } else {
      let data = JSON.parse(e.data)
      let datas = []
      let numOffset = 0
      data.map((item, index) => {
        let obj = {}
        if (index > 0) {
          obj = {
            flag: item,
            offset: numOffset += 100
          }

        } else {
          obj = {
            flag: item,
            offset: 0
          }
        }
        datas.push(obj)

      })
      console.log(datas,"datas")
      if (suc != null) {
        suc.close()
        suc = null
      }
      if (suc1 != null) {
        suc1.close()
        suc1 = null
      }
      if (suc2 != null) {
        suc2.close()
        suc2 = null
      }
      if (suc3 != null) {
        suc3.close()
        suc3 = null
      }
      if (suc4 != null) {
        suc4.close()
        suc4 = null
      }
      for (let i = 0; i < datas.length; i++) {
        if (datas[i].flag == 1) {
          suc = window.app.$notify({
            title: "上门回收订单",
            message: "你有新的上门订单,请前往订单管理中心查看",
            duration: 0,
          });
        } else if (datas[i].flag == 2) {
          suc1 = window.app.$notify({
            title: "线下订单",
            message: "你有新的线下订单，请前往订单管理中心查看",
            duration: 0,
            offset: datas[i].offset
          });
        } else if (datas[i].flag == 3) {
          suc2 = window.app.$notify({
            title: "邮寄回收",
            message: "你有新的邮寄回收订单，请前往订单管理中心查看",
            duration: 0,
            offset: datas[i].offset
          });
        } else if (datas[i].flag == 4) {
          suc3 = window.app.$notify({
            title: "面对面回收订单",
            message: "你有新的面对面回收订单，请前往订单管理中心查看",
            duration: 0,
            offset: datas[i].offset
          });
        } else if (datas[i].flag == 11) {
          suc4 = window.app.$notify({
            title: "以旧换新订单",
            message: "你有新的以旧换新订单，请前往订单管理中心查看",
            duration: 0,
            offset: datas[i].offset
          });
        }

      }
      if (data.length <= 1) {
        handleSpeak(1)
      } else {
        handleSpeak(2)
      }
    }

    // if (e.data == "close") {
    //   clearInterval(clearSetIn)
    //   num = 1
    //   ElementUI.Notification({
    //     title: "该账号已在其他地方登录，请重新登陆",
    //     duration: 6000,
    //   });
    //   socket.onclose()
    // } else if (e.data == "success") {
    //   console.log("心跳持续连接中")
    // } else if (e.data == "有新的订单") {
    //   console.log(e)
    //   handleSpeak()
    //   // reset()
    //   if (suc != null) {
    //     suc.close()
    //     suc = null
    //   }
    //   suc = ElementUI.Notification({
    //     title: "新的未处理订单",
    //     message: "有订单长时间未处理，请前往订单管理中心查看",
    //     duration: 0,
    //   });
    // } else {
    //   reconnect()
    // }

  }
}

// 重置心跳
function reset() {
  // 清除时间
  // clearTimeout(reset)
  // clearTimeout(serverTimoutObj)
}
// 开始
function handleSpeak(num) {
  if (num == 1) {
    msg.text = "有一条订单长时间未处理，请前往订单管理中心查看"; // 文字内容: 小朋友，你是否有很多问号
  } else {
    msg.text = "有多条订单长时间未处理，请前往订单管理中心查看"; // 文字内容: 小朋友，你是否有很多问号
  }

  msg.lang = "zh-CN"; // 使用的语言:中文
  msg.volume = 6; // 声音音量：1
  msg.rate = 1; // 语速：1
  msg.pitch = 10; // 音高：1
  synth.speak(msg); // 播放
}
// 停止
function handleStop(e) {
  msg.text = e;
  msg.lang = "zh-CN";
  synth.cancel(msg);
}






// WEBPACK FOOTER //
// ./src/util/socket.js